import React from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import TravelMapShell from './TravelMapShell.jsx';
import { geographyStyles } from './mapGeographyStyles';

const GEO_URL = "https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/japan.geojson";

const REGIONS = [
    { code: "Aichi", name: "Aichi" },
    { code: "Akita", name: "Akita" },
    { code: "Aomori", name: "Aomori" },
    { code: "Chiba", name: "Chiba" },
    { code: "Ehime", name: "Ehime" },
    { code: "Fukui", name: "Fukui" },
    { code: "Fukuoka", name: "Fukuoka" },
    { code: "Fukushima", name: "Fukushima" },
    { code: "Gifu", name: "Gifu" },
    { code: "Gunma", name: "Gunma" },
    { code: "Hiroshima", name: "Hiroshima" },
    { code: "Hokkaido", name: "Hokkaido" },
    { code: "Hyogo", name: "Hyogo" },
    { code: "Ibaraki", name: "Ibaraki" },
    { code: "Ishikawa", name: "Ishikawa" },
    { code: "Iwate", name: "Iwate" },
    { code: "Kagawa", name: "Kagawa" },
    { code: "Kagoshima", name: "Kagoshima" },
    { code: "Kanagawa", name: "Kanagawa" },
    { code: "Kochi", name: "Kochi" },
    { code: "Kumamoto", name: "Kumamoto" },
    { code: "Kyoto", name: "Kyoto" },
    { code: "Mie", name: "Mie" },
    { code: "Miyagi", name: "Miyagi" },
    { code: "Miyazaki", name: "Miyazaki" },
    { code: "Nagano", name: "Nagano" },
    { code: "Nagasaki", name: "Nagasaki" },
    { code: "Nara", name: "Nara" },
    { code: "Niigata", name: "Niigata" },
    { code: "Oita", name: "Oita" },
    { code: "Okayama", name: "Okayama" },
    { code: "Okinawa", name: "Okinawa" },
    { code: "Osaka", name: "Osaka" },
    { code: "Saga", name: "Saga" },
    { code: "Saitama", name: "Saitama" },
    { code: "Shiga", name: "Shiga" },
    { code: "Shimane", name: "Shimane" },
    { code: "Shizuoka", name: "Shizuoka" },
    { code: "Tochigi", name: "Tochigi" },
    { code: "Tokushima", name: "Tokushima" },
    { code: "Tokyo", name: "Tokyo" },
    { code: "Tottori", name: "Tottori" },
    { code: "Toyama", name: "Toyama" },
    { code: "Wakayama", name: "Wakayama" },
    { code: "Yamagata", name: "Yamagata" },
    { code: "Yamaguchi", name: "Yamaguchi" },
    { code: "Yamanashi", name: "Yamanashi" },
];

const REGION_CODES = REGIONS.map(r => r.code);
const ITEMS = REGIONS.map(r => ({ id: r.code, name: r.name }));

const JapanMapSection = () => {
    const renderMap = ({ visited, hexColor, toggle }) => (
        <ComposableMap
            projection="geoMercator"
            projectionConfig={{ scale: 1600, center: [137, 38] }}
            width={800}
            height={600}
            style={{ width: '100%', height: 'auto' }}
        >
            <Geographies geography={GEO_URL}>
                {({ geographies }) =>
                    geographies
                        .filter(geo => REGION_CODES.includes(geo.properties.name_english))
                        .map((geo) => {
                            const code = geo.properties.name_english;
                            const isVisited = visited.includes(code);
                            return (
                                <Geography
                                    key={geo.rsmKey}
                                    geography={geo}
                                    onClick={() => toggle(code)}
                                    style={geographyStyles(isVisited, hexColor)}
                                />
                            );
                        })
                }
            </Geographies>
        </ComposableMap>
    );

    return (
        <TravelMapShell
            mapType="japan"
            analyticsLocationType="japan"
            trackingLabel="Japan Map"
            storageKey="japan_map"
            title="🇯🇵 Japan Travel Map"
            subtitle="Click on Japanese prefectures you've visited. Or use the checklist below!"
            items={ITEMS}
            noun="Prefectures"
            unitLabel="prefectures"
            captionUnit="Japanese prefectures"
            share={{
                region: 'Japan',
                fileName: 'visited-japan-map.png',
                trackId: 'japan'
            }}
            renderMap={renderMap}
        />
    );
};

export default JapanMapSection;
